import _ from 'lodash';
import moment from 'moment';

class NewsItemController {
  constructor() {
    this.selectedNews = _.extend(this.news, {date: moment(this.news.post_date, 'YYYY-MM-DD hh:mm:ss').toDate()});
    // fix skip empty elements
    this.selectedNews.youtube = _.filter(this.selectedNews.youtube);
  }
}

export default NewsItemController;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsItem/newsItem.controller.js